import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { Subject, takeUntil } from 'rxjs';
import { PaymentStatsGraphComponent } from '../../departments/finance/payment-stats-graph/payment-stats-graph.component';
import { PaymentProgressComponent } from '../../departments/finance/payment-progress/payment-progress.component';
@Component({
  selector: 'app-payment-stats',
  standalone: true,
  imports: [CommonModule, CardModule, PaymentStatsGraphComponent, PaymentProgressComponent],
  templateUrl: './payment-stats.component.html',
  styleUrl: './payment-stats.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentStatsComponent implements OnInit, OnDestroy {
  private ngUnsubscribe = new Subject<void>();

  constructor() {}

  ngOnInit() {
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
} 